import fetch from '../../utils/fetch'

export function chinaUnionticketReverse(params) {
    return fetch({
        url: '/api/ticket/ChinaUnionticketReverse',
        method: 'POST',
        data: params
    })
}

